import apiCall from 'apps/investcore/apiCalls/iap-notifications';
import { columnsGenerator, filterConfig } from 'apps/investcore/components/iap-notifications/config';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import { DetailPage, ListPage } from 'common/ui/admin-CRUD/page';
import ItemDetail from './detail';

export const IapNotificationsListPage = () => (
  <ListPage
    title="IAP Notifications"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={() => <DynamicFilterForm fields={filterConfig} />}
  />
);

export const IapNotificationsDetailPage = () => (
  <DetailPage
    title="IAP Notification"
    apiCall={apiCall}
    listUrl="/investment/iap-notifications"
    ItemDetail={ItemDetail}
  />
);
